<template>
  <div>
    <v-toolbar class="toolbar hidden-md-and-down">
      <v-spacer></v-spacer>
      <v-toolbar-items
        v-for="(item, i) in itemMenu"
        :key="i"
        class="toolbarItem"
      >
        <v-btn :append-icon="item.icon" :href="item.link"
          ><h2 class="btn">{{ item.name }}</h2></v-btn
        >
      </v-toolbar-items>
    </v-toolbar>
    <div class="hidden-lg-and-up">
      <v-layout>
        <v-app-bar  prominent class="drawer">
          <v-toolbar-title> Risen Art</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-app-bar-nav-icon
            variant="text"
            @click.stop="drawer = !drawer"
          ></v-app-bar-nav-icon>
        </v-app-bar>

        <v-navigation-drawer v-model="drawer" temporary location="right">
          <v-list   density="compact"
          nav>
            <v-list-item
              v-for="item in itemMenu"
              :key="item"
              :append-icon="item.icon"
              class="listItemDrawer "
            >
              <router-link :to="item.link" class="x">
                <h3>{{ item.name }}</h3></router-link
              ></v-list-item
            ></v-list
          >
        </v-navigation-drawer>
      </v-layout>
    </div>
  </div>
</template>
<style scoped>


 
</style>
<script>

export default {
  name: "toolbarUser",
  data: () => ({
    drawer: false,
   
  }),
  computed: {
    itemMenu() {
      return this.$store.state.main_menu;
    },
  },

 
};
</script>